import YourReferralAndSavings from "../../components/YourReferralAndSavings"

const YourReferralAndSavingsContainer = ({ setIsLoggedIn }) => (
  <YourReferralAndSavings setIsLoggedIn={setIsLoggedIn} />
);
export default YourReferralAndSavingsContainer;